import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';

export const GetAllUsers = async (page, orgId) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.USER_URL}?page=${page}&limit=10&organizationId=${orgId}`
  );
  return response;
};

export const AddUserData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.USER_URL, data);
  return response;
};

export const UpdateUserProfile = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.USER_URL}/${id}`,
    data
  );
  return response;
};

export const DeleteUserById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.USER_URL}/${id}`
  );
  return response;
};

export const GetUserProfileDetails = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.USER_URL}/${id}`
  );
  return response;
};

export const GetAllUserActivity = async (page, filterBy, search) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.GET_USER_ACTIVITY}?page=${page}&limit=10&filterBy=${filterBy}&search=${search}`
  );
  return response;
};
